export const siteConfig = {
	name: 'MVMNT',
	legalName: 'The MVMNT Group Inc.',
	url: 'https://mvmnt.io',
	lightLogo: 'https://assets.mvmnt.io/mvmnt_logo_black_77cb40472e.svg',
	darkLogo: 'https://assets.mvmnt.io/Logo_4f260a0737.svg',
	lightSquareLogo: 'https://assets.mvmnt.io/Logomark_9997d0975d.svg',
	darkSquareLogo: 'https://assets.mvmnt.io/Logomark_9997d0975d.svg',
	ogImage: 'https://assets.mvmnt.io/xlarge_TMS_Mailer_5d2683a118.webp',
	description: 'Next gen TMS built on the cloud that scales up freight brokerages',
	endActionsTitle: 'Ready to build your team’s dream workflow?',
	links: {
		login: 'https://tms.mvmnt.io',
		forgotPassword: 'https://tms.mvmnt.io/forgot-password',
		signup: '/signup',
		twitter: 'https://x.com/mvmnt_freight'
	},
	keywords: `MVMNT,TMS,Freight Broker,MVMNT TMS,Brokerage,Cloud software,Carrier Sourcing,Capacity,FMCSA,RateLens,AI,Quoting,AI Email Quoting,EDI,API,OpenAPI`
} as const;

// for some reason ui navigation additionalFields.description is not working
export const navDescriptions = {
	TMS: 'The freight brokerage TMS with best-in-class UX',
	'AI Email Quoting': 'Extract load data from customer and carrier emails and send to your TMS',
	RateLens: 'See rates from all your providers in one place',
	Integrations: '20+ integrations to automate your workflows and stop switching tabs',
	API: 'OpenAPI spec to build customized workflows',
	'Carrier Sourcing': 'Search your lane history and our capacity partners',
	EDI: 'Load tender automation with no setup fee and unlimited messages',
	Blog: 'Announcements, use cases and other news',
	'Product Updates': 'Stay up to date with the latest product enhancements',
	'API Reference': 'OpenAPI spec for your developer to start building',
	'App Marketplace': 'See where products in the freight brokerage space rank and find deals',
	'Help Center': 'Learn how to use MVMNT and get detailed answers',
	'Partner Referral Program': 'Become a partner and earn cash by referring friends to MVMNT',
	'TIA 2025': 'Come see us at our booth or schedule a meeting',
	'Broker-Carrier Summit 2025': 'Meet our team in Indianapolis and see us give a live demo'
	// Careers: "We're hiring! Work with a great team in a fast-paced environment"
} as const;

export type SiteConfig = typeof siteConfig;
